  import { Outlet, useLocation } from "react-router-dom";
  import AdminHeader from "../components/AdminHeader";
  import Sidebar from "../components/AdminSidebar";
import {useEffect, useState} from 'react'

  const ADMIN_PAGE_TITLES = {
    "/admin": "Dashboard",
    "/admin/users": "Customer Enquiry",
    "/admin/admin-job-enquiry": "Job Enquiry",
    "/admin/blog": "Blog",
    "/admin/project": "Project Category",
    "/admin/project-category": "Project",
    "/admin/career": "Career",
    "/admin/admin-user": "Admin User",
    "/admin/banner": "Banner",
    "/admin/gallery-category": "Gallery Category",
    "/admin/gallery": "Gallery",
  };

  const AdminLayout = () => {
    const [key, setKey] = useState(0);
    const location = useLocation();
    useEffect(() => {
      setKey(prev => prev + 1); // forces re-render on route change
    }, [location.pathname]);

    useEffect(() => {
      const moduleName = ADMIN_PAGE_TITLES[location.pathname] || "Admin Panel";
      document.title = `${moduleName} | Techno Land`;
    }, [location.pathname]);

    return (
      <>
        <div className="d-flex" key={key}>
          {/* Sidebar (Fixed) */}
          <Sidebar />
  
          {/* Main Content Area (Push Right) */}
          <div
            className="p-4"
            style={{
              marginLeft: "250px",
              width: "100%",
              minHeight: "100vh",
              overflowY: "auto",
            }}
          >
            <Outlet />
          </div>
        </div>
      </>
    );
  };
  

  export default AdminLayout;
